import { useContext, useEffect } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import { useNavigate } from "react-router-dom";
import PanelLayout from "../../../layouts/PanelLayout";

function PerfilEmpleado() {
  const { empleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!empleado) {
      navigate("/loginEmpleados");
    }
  }, [empleado, navigate]);

  if (!empleado) return null;

  return (
    <PanelLayout>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
              <div
                className="p-4 text-white"
                style={{ background: "rgb(61, 102, 81)" }}
              >
                <h2 className="fw-bold mb-1">Perfil del Empleado</h2>
                <p className="mb-0 opacity-75">
                  Consultá tus datos personales y de acceso.
                </p>
              </div>

              <div className="card-body p-4 p-lg-5">
                <div className="row g-4 align-items-center">
                  <div className="col-md-4 text-center">
                    <div
                      className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center mx-auto shadow"
                      style={{ width: 120, height: 120, fontSize: 40 }}
                    >
                      {empleado.nombre?.charAt(0) || "E"}
                    </div>

                    <h4 className="mt-3 fw-bold mb-1">
                      {empleado.nombre} {empleado.apellido}
                    </h4>

                    <span className="badge bg-secondary px-3 py-2">
                      {empleado.rol || "Empleado"}
                    </span>
                  </div>

                  <div className="col-md-8">
                    <div className="row g-3">
                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">Nombre</small>
                          <div className="fw-semibold">{empleado.nombre || "-"}</div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">Apellido</small>
                          <div className="fw-semibold">
                            {empleado.apellido || "-"}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">CUIT</small>
                          <div className="fw-semibold">{empleado.cuit || "-"}</div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">Email</small>
                          <div className="fw-semibold">{empleado.mail || "-"}</div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">Estado</small>
                          <div className="fw-semibold text-success">Activo</div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="border rounded-3 p-3 bg-light h-100">
                          <small className="text-muted d-block mb-1">
                            Tipo de Cuenta
                          </small>
                          <div className="fw-semibold">Empleado</div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 d-flex gap-2 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-success rounded-pill px-4"
                        onClick={() => navigate("/dashboardEmpleados")}
                      >
                        Volver al panel
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-success rounded-pill px-4"
                        onClick={() => navigate("/cambiar-password")}
                      >
                        Cambiar contraseña
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}

export default PerfilEmpleado;
